import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Rafael O.',
  age: 52,
  location: 'Buenos Aires',
  quote: "I've read Tolle, Dispenza, Singer. This book connects the dots they all left loose. The map I was missing.",
  image: 'https://i.pravatar.cc/150?img=11'
}, {
  name: 'Camila F.',
  age: 29,
  location: 'Bogotá, Colombia',
  quote: 'Chapter 5 changed how I see every relationship in my life. I finally understood the contracts.',
  image: 'https://i.pravatar.cc/150?img=5'
}, {
  name: 'Sarah J.',
  age: 34,
  location: 'London, UK',
  quote: 'The framework for reality architecture blew my mind. I finally understand why I kept repeating the same patterns.',
  image: 'https://i.pravatar.cc/150?img=9'
}, {
  name: 'Michael T.',
  age: 45,
  location: 'New York, USA',
  quote: 'A practical guide to waking up. No fluff, just direct, actionable wisdom that actually shifts your perspective.',
  image: 'https://i.pravatar.cc/150?img=3'
}, {
  name: 'Elena R.',
  age: 28,
  location: 'Madrid, Spain',
  quote: 'I felt like the authors were speaking directly to my soul. This is not just a book, it is an initiation.',
  image: 'https://i.pravatar.cc/150?img=24'
}, {
  name: 'Kenji S.',
  age: 31,
  location: 'Tokyo, Japan',
  quote: 'Finally, a spiritual guide that respects the intellect while opening the heart. Truly transformative.',
  image: 'https://i.pravatar.cc/150?img=15'
}, {
  name: 'Isabella M.',
  age: 39,
  location: 'Rome, Italy',
  quote: 'The audio version is hypnotic. I listen to it during my commute and arrive at work feeling completely different.',
  image: 'https://i.pravatar.cc/150?img=44'
}, {
  name: 'David K.',
  age: 42,
  location: 'Berlin, Germany',
  quote: 'If you are ready to stop playing small and start playing the real game, this is the manual you need.',
  image: 'https://i.pravatar.cc/150?img=60'
}];
export function SocialProofSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="pt-4 pb-16 md:pt-8 md:pb-24 bg-gradient-to-b from-black via-neutral-950/50 to-black overflow-hidden" data-id="element-738">
      <div className="max-w-7xl mx-auto px-6" data-id="element-739">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-740">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wider uppercase border rounded-full bg-teal-500/20 text-teal-400 border-teal-500/30 mb-6" data-id="element-741">
            What Readers Are Saying
          </span>
          <div className="flex items-center justify-center gap-1 mb-3" data-id="element-742">
            <StarIcon className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-743" />
            <StarIcon className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-744" />
            <StarIcon className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-745" />
            <StarIcon className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-746" />
            <StarIcon className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-747" />
          </div>
          <p className="text-neutral-400 text-sm" data-id="element-748">
            4.9 / 5 — 2,400+ readers in 14 countries
          </p>
        </motion.div>

        {/* Testimonials Carousel */}
        <div className="flex overflow-x-auto gap-6 pb-8 snap-x snap-mandatory scrollbar-hide -mx-6 px-6 md:mx-0 md:px-0" data-id="element-749">
          {TESTIMONIALS.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1 + index * 0.1
        }} className="flex-shrink-0 w-[85vw] md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] snap-center p-6 md:p-8 rounded-2xl bg-neutral-900/60 border border-neutral-800/50 flex flex-col justify-between" data-id="element-750">
              <div data-id="element-751">
                <div className="flex gap-0.5 mb-4" data-id="element-752">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-753" />)}
                </div>
                <p className="font-serif text-lg text-neutral-200 italic leading-relaxed mb-6" data-id="element-754">
                  "{testimonial.quote}"
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-755">
                <img src={testimonial.image} alt={testimonial.name} className="w-10 h-10 rounded-full object-cover border border-neutral-700" data-id="element-756" />
                <div data-id="element-757">
                  <p className="text-white text-sm font-semibold" data-id="element-758">
                    {testimonial.name}, {testimonial.age}
                  </p>
                  <p className="text-neutral-500 text-xs" data-id="element-759">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}